import { render, staticRenderFns } from "./whatwedo.vue?vue&type=template&id=ffad576a&scoped=true&"
import script from "./whatwedo.vue?vue&type=script&lang=js&"
export * from "./whatwedo.vue?vue&type=script&lang=js&"
import style0 from "./whatwedo.vue?vue&type=style&index=0&id=ffad576a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffad576a",
  null
  
)

export default component.exports